/* eslint-disable max-lines-per-function */
import React from "react";
import { gql } from "graphql-tag";
import { useQuery } from "@apollo/client";
import { Link, RouteComponentProps, navigate } from "@reach/router";
import MaterialTable from "@material-table/core";
import { ServerError } from "components/graphql-views";
import { getLists, getOrganizations } from "types/gql-types";

const GET_LISTS = gql`
  query getLists {
    interestLists(includeArchived: true) {
      id
      name
      type
      organizationId
      isArchived
    }
  }
`;
const GET_ORGS = gql`
  query getOrganizations {
    organizations {
      id
      name
    }
  }
`;

const Lists: React.FC<RouteComponentProps> = () => {
  const { loading, error, data } = useQuery<getLists>(GET_LISTS, { fetchPolicy: "cache-and-network" });
  const { loading: loadingOrgs, error: errorOrgs, data: dataOrgs } = useQuery<getOrganizations>(GET_ORGS, { fetchPolicy: "cache-and-network" });
  if (error) return <ServerError desc={error.message} />;
  if (errorOrgs) return <ServerError desc={errorOrgs.message} />;
  if (!data || !dataOrgs) return null;
  const organizationNamesMap = dataOrgs.organizations
    .reduce((acc, { id, name }) => ({
      ...acc,
      [id]: name,
    }), {} as Record<string, string>);
  return (
    <MaterialTable
      actions={[
        {
          icon: "add",
          tooltip: "Create Interest List",
          isFreeAction: true,
          onClick: () => navigate("lists/new"),
        },
      ]}
      title="Interest Lists"
      isLoading={loading || loadingOrgs}
      data={data && data.interestLists}
      options={{
        groupTitle: ({ value }: any) => organizationNamesMap[value] || "Unknown",
        grouping: true,
        pageSize: 50,
        pageSizeOptions: [50, 100, 200, 500],
      }}
      columns={[
        {
          grouping: false,
          field: "name",
          title: "Interest List Name",
          defaultSort: "asc",
          render: ({ id, name }) => <Link to={id}>{name}</Link>,
        }, {
          field: "organizationId",
          title: "Organization Name",
          defaultGroupOrder: 0,
          render: ({ organizationId }) => organizationNamesMap[organizationId],
        }, {
          field: "isArchived",
          title: "Is Archived",
          render: ({ isArchived }) => (isArchived ? "Archived" : "Active"),
          customFilterAndSearch: (filterText, row) => {
            const archivedText = row.isArchived ? "Archived" : "Active";
            return archivedText.toLowerCase().includes(filterText.toLowerCase());
          },
        },
      ]} />
  );
};

export default Lists;
